import type { PickAnalyticsEventAttributes } from '../../../../types'
import { analyticsEvents } from '../../integration/analytics-multiplatform-sdk'

export const ProductAdded = (attributes: PickAnalyticsEventAttributes<'ProductAdded'>) => {
  const { ProductAdded } = analyticsEvents
  const {
    product,
    productAddedOrigin,
    storeAddressId,
    productSelectionOrigin,
    collectionId,
    collectionGroupId,
    categoryId,
    productId,
    collectionGroupType,
    collectionGroupName,
    productLabel,
    isSponsored,
    productImageTags,
    productValue,
    storeId,
    userSelectedLanguage,
    storeProductId,
    isRestricted,
    searchId,
    isCustomisable,
    attributesCount,
    sectionsCount,
    requiredSectionsCount,
    basketId,
    increment,
    productSaleType,
    isWeightedProduct,
    productVariantGroupId,
    numAvailableVariants,
    isPaginated,
  } = attributes

  return new ProductAdded(
    product,
    productAddedOrigin,
    storeAddressId,
    productSelectionOrigin,
    collectionId,
    collectionGroupId,
    categoryId,
    productId,
    collectionGroupType,
    collectionGroupName,
    productLabel,
    isSponsored,
    productImageTags,
    productValue,
    storeId,
    userSelectedLanguage,
    storeProductId,
    isRestricted,
    searchId,
    isCustomisable,
    attributesCount,
    sectionsCount,
    requiredSectionsCount,
    basketId,
    increment,
    productSaleType,
    isWeightedProduct,
    productVariantGroupId,
    numAvailableVariants,
    isPaginated
  )
}

export const ProductRemoved = (attributes: PickAnalyticsEventAttributes<'ProductRemoved'>) => {
  const { ProductRemoved } = analyticsEvents
  const {
    product,
    productRemovedOrigin,
    storeAddressId,
    collectionId,
    collectionGroupId,
    categoryId,
    productId,
    collectionGroupType,
    collectionGroupName,
    productLabel,
    isSponsored,
    storeId,
    storeProductId,
    basketId,
  } = attributes

  return new ProductRemoved(
    product,
    productRemovedOrigin,
    storeAddressId,
    collectionId,
    collectionGroupId,
    categoryId,
    productId,
    collectionGroupType,
    collectionGroupName,
    productLabel,
    isSponsored,
    storeId,
    storeProductId,
    basketId
  )
}

export const CheckoutOrderButtonPressed = (
  attributes: PickAnalyticsEventAttributes<'CheckoutOrderButtonPressed'>
) => {
  const { CheckoutOrderButtonPressed } = analyticsEvents
  const {
    properties,
    validationErrors,
    orderSubmitted,
    paymentMethod,
    origin,
    isReorder,
    searchId,
  } = attributes
  return new CheckoutOrderButtonPressed(
    properties,
    validationErrors,
    orderSubmitted,
    paymentMethod,
    origin,
    isReorder,
    searchId
  )
}
